import EsignCallbackPage from '@/client-portal/pages/EsignCallbackPage.vue';
import MultiFactorAuthenticationSend from '@/company-portal/pages/MultiFactorAuthenticationSend.vue';
import MultiFactorAuthenticationVerify from '@/company-portal/pages/MultiFactorAuthenticationVerify.vue';
import CsrfField from '@/components/auth/CsrfField.vue';
import BankAccountVerificationReportWrapper from '@/components/Components/BankAccountVerification/BankAccountVerificationReportWrapper.vue';
import IdentityVerificationReportWrapper from '@/components/Components/IdentityVerificationReport/IdentityVerificationReportWrapper.vue';
import IdentityVerificationReviewWrapper from '@/components/Components/IdentityVerificationReview/IdentityVerificationReviewWrapper.vue';
import PayoffDetailsWrapper from '@/components/Components/Payoff/PayoffDetailsWrapper.vue';
import RequestDocumentWrapper from '@/components/Components/RequestDocument/RequestDocumentWrapper.vue';
import DesignSamples from '@/components/design-system/design-samples/DesignSamples.vue';
import DsAddressAutocompleteSearch from '@/components/design-system/form/input/DsAddressAutocomplete/DsAddressAutocompleteSearch.vue';
import ClosinglockHeader from '@/components/Navigation/ClosinglockHeader.vue';
import CompanyNavigation from '@/components/Navigation/top-nav/CompanyNavigation.vue';
import EmployeeNavigation from '@/components/Navigation/top-nav/EmployeeNavigation.vue';
import ShadowButton from '@/components/Navigation/top-nav/ShadowButton.vue';
import ShadowWarning from '@/components/Navigation/top-nav/ShadowWarning.vue';
import AccountActions from '@/components/PageSections/AccountActions.vue';
import AddFileForm from '@/components/Views/Company/AddFile/AddFileForm.vue';
import AddFileFormHeader from '@/components/Views/Company/AddFile/AddFileFormHeader.vue';
import ClientMultiSelect from '@/components/Views/Company/AddFile/ClientMultiSelect.vue';
import ClientsSection from '@/components/Views/Company/AddFile/ClientsSection.vue';
import DocumentUploadSection from '@/components/Views/Company/AddFile/DocumentUploadSection.vue';
import FileDetailsSection from '@/components/Views/Company/AddFile/FileDetailsSection.vue';
import NotificationSection from '@/components/Views/Company/AddFile/NotificationSection.vue';
import RequestIdentityVerificationSection from '@/components/Views/Company/AddFile/RequestIdentityVerificationSection.vue';
import RequestWireInformationSection from '@/components/Views/Company/AddFile/RequestWireInformationSection.vue';
import SendWireInstructionsSection from '@/components/Views/Company/AddFile/SendWireInstructionsSection.vue';
import CompanyFooter from '@/components/Views/Company/CompanyFooter.vue';
import EarlyDepositForm from '@/components/Views/Company/EarlyDepositForm.vue';
import AutomatedTaskReminders from '@/components/Views/Company/Settings/AutomatedTaskReminders.vue';
import BootstrapCheckbox from '@/components/Views/Company/Settings/BootstrapCheckbox.vue';
import EvidenceOfInsurance from '@/components/Views/Company/Settings/EvidenceOfInsurance.vue';
import WatermarkOnWireInstructions from '@/components/Views/Company/Settings/WatermarkOnWireInstructions.vue';
import ViewEarlyDepositTable from '@/components/Views/Company/ViewEarlyDepositTable.vue';
import StateSelector from '@/employee-portal/shared/StateSelector.vue';
import CompanyPortalCommonLayout from '@/layouts/CompanyPortalCommonLayout.vue';

/*
  This list contains components that are used as entry points when initVueSprinkle is used.
  Descendant components are resolved as usual
  When using them in blade templates, declare the component tag using <kebab-case />
*/
export const allComponents = {
    AccountActions,
    AddFileForm,
    AddFileFormHeader,
    AutomatedTaskReminders,
    BankAccountVerificationReportWrapper,
    BootstrapCheckbox,
    ClientMultiSelect,
    ClientsSection,
    ClosinglockHeader,
    CompanyFooter,
    CompanyNavigation,
    CompanyPortalCommonLayout,
    CsrfField,
    DesignSamples,
    DocumentUploadSection,
    DsAddressAutocompleteSearch,
    EarlyDepositForm,
    EmployeeNavigation,
    EsignCallbackPage,
    EvidenceOfInsurance,
    FileDetailsSection,
    IdentityVerificationReportWrapper,
    IdentityVerificationReviewWrapper,
    MultiFactorAuthenticationSend,
    NotificationSection,
    MultiFactorAuthenticationVerify,
    PayoffDetailsWrapper,
    RequestDocumentWrapper,
    RequestIdentityVerificationSection,
    RequestWireInformationSection,
    SendWireInstructionsSection,
    ShadowButton,
    ShadowWarning,
    StateSelector,
    ViewEarlyDepositTable,
    WatermarkOnWireInstructions,
};
